import { styled } from 'styled-components';
import bg from '@assets/images/background/button-quit.png';

type IProps = {
  onClick?: () => void;
};

type TProps = IProps;

export function ButtonQuit({ onClick }: TProps) {
  return (
    <Container
      $background={bg}
      onClick={(e) => {
        e.stopPropagation();
        onClick && onClick();
      }}
    />
  );
}

const Container = styled.button<{ disabled?: boolean; $background?: string }>`
  align-items: center;
  border-radius: 57.778px;
  background: ${({ $background }) =>
    $background
      ? `url('${$background}') center/contain no-repeat transparent`
      : 'none'};
  border: none;
  cursor: pointer;
  transition: all 0.3s linear;
  outline: none;
  pointer-events: auto;
  width: 65px;
  height: 65px;
  z-index: 1000;

  @media screen and (max-height: 800px) {
    width: 58px;
    height: 58px;
  }
  @media screen and (max-width: 450px) {
    width: 44px;
    height: 44px;
    min-width: 44px;
  }

  @media screen and (max-height: 415px) {
    width: 44px;
    height: 44px;
    min-width: 44px;
  }

  &:focus {
    transform: scale(1.1);
  }

  &:hover {
    transform: scale(1.1);
  }
`;

/*
Bouton Quitter dans le mode Battle : pop up 

==> si je suis défiée :
 Attention en quittant le défi vous déclarez forfait et votre adversaire gagne ce défi.
Quitter le défi / Rester sur le défi

==> Si je défie : 
Attention en quittant, ce défi sera supprimé.
Quitter le défi / Rester sur le défi
*/
